import { CollapseAll, ExpandAll } from '@/components/ui/icons';
import { cn } from '@/components/ui/cn';

/**
 * A compact segmented "collapse all / expand all" control shared by the Table and Kanban toolbars,
 * so both views fold and unfold their trees the same way. Two icon buttons in one rounded-pill
 * shell (matching the header dropdown pills). Renders nothing when there's nothing collapsible, so
 * a flat board doesn't show inert controls.
 */
export default function CollapseExpand({
  onCollapseAll,
  onExpandAll,
  show = true,
}: {
  onCollapseAll: () => void;
  onExpandAll: () => void;
  /** Hide when the current view has no expandable rows/cards. */
  show?: boolean;
}) {
  if (!show) return null;
  const btn =
    'flex h-7 w-7 items-center justify-center rounded-full text-fg-muted transition-colors hover:bg-layer-strong hover:text-fg';
  return (
    <div className="inline-flex items-center rounded-full border border-line bg-surface-inset p-0.5">
      <button type="button" onClick={onCollapseAll} className={btn} aria-label="Collapse all" title="Collapse all">
        <CollapseAll />
      </button>
      <span className="mx-0.5 h-4 w-px bg-line" aria-hidden="true" />
      <button type="button" onClick={onExpandAll} className={cn(btn)} aria-label="Expand all" title="Expand all">
        <ExpandAll />
      </button>
    </div>
  );
}
